<template>
    <div class="auth-wrapper">
        <div v-if="!isMobile" class="auth-wrapper auth-wrapper-left"></div>

        <div class="auth-wrapper-rigth">
            <div class="auth-wrapper__content">
                <div class="auth-wrapper__logo logo">
                    <figure class="figure-logo">
                        <img src="/static/logos/logo_dv7.png" alt="40%" width="80%">
                    </figure>
                </div>

                <lang-select class="set-language"/>

                <el-form
                    :model="model"
                    :rules="rules"
                    ref="form"
                    label-position="left"
                    label-width="0px"
                    @submit.native.prevent="submit"
                >
                    <el-form-item prop="email">
                        <el-input
                            type="text"
                            v-model="model.email"
                            @keyup.enter.native="submit"
                            auto-complete="off"
                            :placeholder="$t('auth.login.email')"
                            ref="focus"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            type="password"
                            v-model="model.password"
                            @keyup.enter.native="submit"
                            auto-complete="off"
                            :placeholder="$t('auth.login.password')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item style="width:100%;">
                        <el-button
                            type="primary"
                            style="width:100%;"
                            @click="submit"
                            :loading="loading"
                        >{{$t("auth.login.logIn")}}</el-button>
                    </el-form-item>
                    <el-form-item class="text-center">
                        <router-link
                            :to="{ name: 'passwordReset' }"
                        >{{$t('auth.login.forgotPassword')}}</router-link>
                        <br>
                        <!-- <router-link :to="{ name: 'registration' }">Sign up for an account</router-link> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import validators from "@/shared/form/validators";
import LangSelect from "@/components/LangSelect";

export default {
    name: "app-login",
    components: { LangSelect },
    data() {
        return {
            rules: {
                email: validators.string({
                    label: this.$t("auth.login.email"),
                    required: true
                }),
                password: validators.string({
                    label: this.$t("auth.login.password"),
                    required: true
                })
            },
            model: {}
        };
    },

    computed: {
        ...mapGetters({
            loading: "auth/loading",
            isMobile: "shared/isMobile"
        })
    },

    methods: {
        submit() {
            this.$refs.form.validate().then(valid => {
                if (!valid) {
                    return;
                }

                this.$store
                    .dispatch("auth/signin", {
                        email: this.model.email,
                        password: this.model.password
                    })
                    .then(() => {
                        // eslint-disable-next-line
                        console.log(" FINALICE");

                        this.$router.push("/");
                    });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.set-language {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/auth/login/login.vue?7a887970